import { render, staticRenderFns } from "./Import.vue?vue&type=template&id=6242e978&scoped=true&"
import script from "./Import.vue?vue&type=script&lang=js&"
export * from "./Import.vue?vue&type=script&lang=js&"
import style0 from "./Import.vue?vue&type=style&index=0&id=6242e978&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6242e978",
  null
  
)

export default component.exports